import React,{useState} from 'react';


export function useStateWithLocalStorage (key,defaultValue,isJSON=true){
    // Pass initial state function to useState so logic is only executed once
    const [storedValue, setStoredValue] = useState(() => {
        
        // Get from local storage by key
        const item = sessionStorage.getItem(key);
        // Parse stored json or if none return initialValue
        return item ? (isJSON?JSON.parse(item):item) : defaultValue;
        
    });
   
    const setValue=value=>{
        const valueToStore =
        value instanceof Function ? value(storedValue) : value;
        // Save state
        setStoredValue(valueToStore);
        // Save to local storage
        sessionStorage.setItem(key, isJSON?JSON.stringify(valueToStore):valueToStore);
    };
   
    return [storedValue, setValue];
}

